import * as intelligentSchedulingTranslationsDe from './lib/translations.de.json';
import * as intelligentSchedulingTranslationsEn from './lib/translations.en.json';

export {
  intelligentSchedulingTranslationsDe,
  intelligentSchedulingTranslationsEn,
};
export * from './lib/CreateButtonWithPopup';
